import React, { useEffect } from "react";

export const RedirectControlSurvey = (props: { isLtikSession: boolean }) => {
    const CONTROL_SURVEY_URL = "https://fullerton.qualtrics.com/jfe/form/SV_2oc5vadc64wsl8O";

    useEffect(() => {
        if (props.isLtikSession) {
            window.location.href = CONTROL_SURVEY_URL;
        }
    }, [props.isLtikSession]);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            Redirecting to Qualtrics...
        </div>
    );
}